import { Button } from '@flos/react-ui';

const ContactUs = (): JSX.Element => {
    const onRedirectHandler = () => {
        window.location.assign('https://www.topdanmark.dk/faa-hjaelp/kontakt-os/');
    };
    return (
        <>
            <h4>Vi kan desværre ikke give dig en pris online</h4>
            <p>
                Vi vil dog rigtig gerne hjælpe dig med forsikringen, vi er bare nødt til at tale sammen først.
                <br />
                <br />
                Kontakt os, så vi kan finde den bedste forsikringsløsning til dig.
            </p>
            <Button
                style={{ marginTop: 20, marginBottom: 20 }}
                onClick={() => onRedirectHandler()}
                data-testid="contact-btn"
            >
                Kontakt os
            </Button>
        </>
    );
};

const AlreadyCovered = (): JSX.Element => {
    const onRedirectHandler = () => {
        let host = window.topContext.config.getSiteConfig().sisterHost;
        let url = `https://${host}/forsikringer/`;
        window.location.assign(url);
    };
    return (
        <>
            <h4>Åh beklager!</h4>
            <p>
                Jeg kan se, at dit køretøj allerede er dækket hos os. Du kan se forsikringen i Mit Topdanmark.
                <br />
                <br /> Hvis du ikke kan se forsikringen i Mit Topdanmark, kan det skyldes, at den står registreret i din
                partners navn.
            </p>
            <Button
                style={{ marginTop: 20, marginBottom: 20 }}
                onClick={() => onRedirectHandler()}
                data-testid="contact-btn"
            >
                Gå til Mit Topdanmark
            </Button>
        </>
    );
};

const BornholmRedirect = (): JSX.Element => {
    const onRedirectHandler = () => {
        window.location.assign('https://bornbrand.dk/privat/bilforsikring/');
    };
    return (
        <>
            <h4>Fortsæt hos Bornholms Brandforsikring</h4>
            <p>Som bosat på Bornholm skal du købe vores forsikringer gennem Bornholms Brandforsikring.</p>
            <Button
                style={{ marginTop: 20, marginBottom: 20 }}
                onClick={() => onRedirectHandler()}
                data-testid="contact-btn"
            >
                Gå til Bornholms Brandforsikring
            </Button>
        </>
    );
};

export { ContactUs, AlreadyCovered, BornholmRedirect };
